<template>
  <div id="basic-confirm-modal">
    <v-dialog
      transition="dialog-top-transition"
      width="340px"
      v-model="showModal"
    >
      <v-card height="auto">
        <v-toolbar color="primary" :title="title">
          <v-btn icon dark>
            <v-icon @click="cancelButtonClicked">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <div class="text-subtitle-1 text-center py-4">
            {{ this.subTitle }}
          </div>
        </v-card-text>
        <v-card-actions class="justify-space-between">
          <v-btn variant="text" @click="cancelButtonClicked">{{
            $t("users.table.deleteModal.cancelButton")
          }}</v-btn>
          <v-btn variant="text" @click="okButtonClicked">{{
            $t("users.table.deleteModal.okButton")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "basicConfirmModal",
  props: {
    title: {
      type: String,
      required: true,
    },
    subTitle: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showModal: false,
      confirmId: undefined,
    };
  },
  created() {
    this.emitter.on("showBasicConfirmModal", (id) => {
      this.showModal = true;
      this.confirmId = id;
    });
  },
  methods: {
    okButtonClicked() {
      this.showModal = false;
      this.emitter.emit("basicConfirmModalConfirmed", this.confirmId);
    },
    cancelButtonClicked() {
      this.showModal = false;
    },
  },
  beforeUnmount() {
    this.emitter.off("showBasicConfirmModal");
  },
};
</script>

<style lang="scss" scoped></style>
